export class ContactNewPasswordDTO {
    public token: string
    public newPassword: string
    constructor(
        token: string,
        newPassword: string,
    ) {
        this.token = token
        this.newPassword = newPassword
    }
}
